module.exports = __webpack_public_path__ + "static/media/login_background.30fd8ca5.png";